<div class="my-5">

  <div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data"></sm-data-table-builder>
  </div>
